import can from 'can';
import $ from 'jquery';
import {BaseCloudinaryModule} from '../../js/usga.base-module';

export const Tabs = BaseCloudinaryModule.extend(
	{
		tickerData: null,

		getTickerData: function () {
			const deferred = $.Deferred();

			if (Tabs.tickerData !== null) {
				deferred.resolve(Tabs.tickerData);
			}
			else {
				let interval;

				interval = setInterval(function () {
					if (Tabs.tickerData !== null) {
						clearInterval(interval);
						deferred.resolve(Tabs.tickerData);
					}
				}, 100);
			}

			return deferred.promise();
		}
	},
	{
		emptyImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=',
		sponsorTemplate: '<span class="tabbable-head__partner">IN PARTNERSHIP WITH<img alt="" class="tabbable-head__partner__logo" data-crop="fit"></span>',
		sponsorClass: 'tabbable-head_with-partner',
		updateLabelTemplate: '<div class="microsite__header__update"><span class="microsite__header__update__icon"></span>Updates every 30 secs</div>',
		hasSponsor: false,
		tabContainer: null,
		logoContainer: null,
		updateLabelContainer: null,
		updateLabelCreated: false,

		init: function () {
			this._super();
			Tabs.tickerData = {
				startDate: this.options.tickerStartDate,
				endDate: this.options.tickerEndDate
			};
		},
		onDocumentReady: function () {
			if (this.options.items) {
				this.checkTimes();
			} else {
				this.initTabDrop();
			}
			this.tabContainer = this.element.find('.nav-tabs');
			this.logoContainer = this.element.find('.tabbable-head');
			this.updateLabelContainer = can.$('.microsite__header');
		},

		checkTimes: function () {
			can.ajax({
				type: 'GET',
				url: this.options.startingTimesFeed,
				headers: {
					'Content-Type': 'application/json'
				},
				success: this.proxy(function (data) {
					if (data && typeof(data) == 'object') {
						this.createTabs(true);
					} else {
						this.createTabs(false);
					}
				}),
				error: this.proxy(function () {
					this.createTabs(false);
				})
			});
		},

		createTabs: function (times) {
			const now = new Date().valueOf();
			const startDate = this.options.tickerStartDate;
			const tabs = this.options.items;
			let i = 0;
			const ii = tabs.length;
			for (; i < ii; i++) {
				const tab = tabs[i];
				if (!tab.hide) {
					switch (tab.type) {
						case 'editorial':
							this.addTab(tab.name, tab.active, tab.link);
							break;
						case 'startingTimes':
							if (times) {
								this.addTab(tab.name, tab.active, tab.link);
							}
							break;
						case 'scoring':
						case 'statistics':
							if (startDate <= now) {
								this.addTab(tab.name, tab.active, tab.link);
								if (tab.active && !this.updateLabelCreated) {
									this.createUpdateLabel();
								}
							}
							break;
						default:
							this.addTab(tab.name, tab.active, tab.link);
							break;
					}
					if (tab.active && !tab.hideSponsorLogo) {
						this.createSponsorLogo(tab.sponsorLogo);
					}
				}
			}
			this.initTabDrop();
		},

		addTab: function (text, active, link) {
			const $tab = $('<li><a href="">' + text + '</a></li>');
			if (active) {
				$tab.addClass('active');
			} else {
				$tab.find('a').attr('href', link);
			}
			this.tabContainer.append($tab);
		},

		createUpdateLabel: function () {
			const $updateLabel = $(this.updateLabelTemplate);
			this.updateLabelContainer.append($updateLabel);
			this.updateLabelCreated = true;
		},

		createSponsorLogo: function (url) {
			const $logo = can.$(this.sponsorTemplate);
			const image = $logo.find('img');
			image.attr('data-src', url);
			image.attr('src', this.emptyImage);
			this.logoContainer.prepend($logo);
			this.logoContainer.addClass(this.sponsorClass);
			this.hasSponsor = true;
			this.applyCloudinary(this.logoContainer);
		},

		initTabDrop: function () {
			this.$element.find('.nav-tabs-drop')
				.tabdrop({
					updateSelect: true
				})
				.on('tabChange', this.proxy(this.onTabChanged));
		},

		onLayout: function () {
			if (this.hasSponsor) {
				this.applyCloudinary(this.logoContainer);
			}
		},

		onTabChanged: function (event, tabId) {
			this.trigger('onTabChanged', tabId);
		}
	}
);